import { withStyles } from '@material-ui/core';
import { HeaderDetails } from '.';

const styles = (theme) => ({
  container: {
    position: 'relative',
    display: 'block',
    width: '100%'
  },
  logoContainer: {
    position: 'absolute',
    top: '0',
    right: '0',
    padding: '5px',
    height: '20px',
    zIndex: 500
  },
  title: {
    color: theme.printTableLabel,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: '1px',
    textDecorationLine: 'underline',
    textTransform: 'uppercase',
    textAlign: 'center'
  },
  groupContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    marginTop: 10,
  },
});

const DefaultPrintHeader = ({ classes, title = '', headerDetails = [] }) => {
  return (
    <span className="onlyPrint">
      <div className={classes.container}>
        <div className={classes.title}>{title}</div>
        <div className={classes.groupContainer}>
          {headerDetails?.map((item, idx) => (
            <div key={idx} className={item.className || classes.item}>
              <HeaderDetails label={item.label} value={item.value} />
            </div>
          ))}
        </div>
        <img
          src="../../../../../../images/RouteMax_Logo_Print.svg"
          className={classes.logoContainer}
        />
      </div>
    </span>
  );
};

export default withStyles(styles)(DefaultPrintHeader);
